/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 2194421430@qq.com
 * @Date: 2021-04-19 12:05:04
 * @LastEditors: sj
 * @LastEditTime: 2022-06-20 16:45:40
 */
import {
  Button,
  Col,
  Collapse,
  Dropdown,
  Form,
  Menu,
  Modal,
  Row,
  Select,
  Space,
  Tabs,
} from "antd"
import React, { useEffect, useRef, useState } from "react"
import styles from "./filing.module.css"
import { TabBar } from "../../compnents/widgets/TabBar"
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined, UpOutlined } from "@ant-design/icons"
import { useDispatch, useSelector } from "react-redux"
import {
  selectAppToken,
  selectTenantCityCode,
  selectUserName,
} from "../../app/applicationSlice"
import { EditableList } from "../../compnents/list/EditableList"
import { CTYXColumns, DJDPColumns, KJYWColumns, SSJSSColumns, YZBAColumns, ZYTFColumns, ZYTSLFColumns } from "./columns"
import { RecordsModal } from "./TcmPasting/RecordsModal"
import { ZYTFFormModal } from "./TcmPasting/ZYTFFormModal"
import { ZYTFAgainModal } from "./TcmPasting/ZYTFAgainModal"
import { useHistory, useLocation } from "react-router-dom"
import axios from "axios"
import { getSJWHTokenAsync } from "../dataMaintenance/organization/data"
import { unwrapResult } from "@reduxjs/toolkit"
import { RootDispatch } from "../../app/store"
import { RecordsSpecialModal } from "./TcmSpecial/RecordsSpecialModal"
import { ZYTSLFFormModal } from "./TcmSpecial/ZYTSLFFormModal"
import { AXIOS_IP, FillingType } from "./fileUploadService"
import { RecordsCTYXModal } from "./TraditionalMedicine/RecordsTraditionalModal"
import { CTYXFFormModal } from "./TraditionalMedicine/CTYXFFormModal"
import { RecordsLKJYWModal } from "./AntimicrobialDrugs/RecordsSpecialModal"
import { KJYWFormModal } from "./AntimicrobialDrugs/KJYWFormModal"
import { KJYWTemporaryModal } from "./AntimicrobialDrugs/KJYWTemporaryModal"
import { RecordsYZBAModal } from "./FreeMedica/RecordsFreeMedicaModal"
import { CTYXAgainModal } from "./TraditionalMedicine/CTYXAgainModal"
import { YZBAFormModal } from "./FreeMedica/YZBAFormModal"
import { DJDPFormModal } from "./ReplaceMake/DJDPFormModal"
import { RecordsDJDPModal } from "./ReplaceMake/RecordsDJDPModal"
import { DJDPAgainModal } from "./ReplaceMake/DJDPAgainModal"
import FillingSvg from '../../compnents/icons/svg/filled/filling.svg'
import { SSJSSFormModal } from "./SurgicalCatalog/SSJSSFormModal"
import { RecordsSurgicalModal } from "./SurgicalCatalog/RecordsSurgicalModal"

export const FilingManagement = () => {
  const { TabPane } = Tabs

  const cityCode = useSelector(selectTenantCityCode)

  const location: any = useLocation()

  const [token, setToken] = useState("")

  const dispatch = useDispatch<RootDispatch>()

  const [showContent, setShowContent] = useState(JSON.parse(sessionStorage.getItem('showFilingManagement') || 'true'))

  // 添加 Ctrl 键状态跟踪
  const [ctrlPressed, setCtrlPressed] = useState(false)

  //义诊备案
  const [recordsYZBAVisible, setRecordsYZBAVisible] = useState(false)
  const [YZBAFormVisible, setYZBAFormVisible] = useState(false)

  //代煎代配
  const [recordsDJDPVisible, setRecordsDJDPVisible] = useState(false)
  const [DJDPFormVisible, setDJDPFormVisible] = useState(false)
  const [DJDPAgainVisible, setDJDPAgainVisible] = useState(false)

  //中医贴敷
  const [recordsVisible, setRecordsVisible] = useState(false)
  const [ZYTFFormVisible, setZYTFFormVisible] = useState(false)
  const [ZYTFAgainVisible, setZYTFAgainVisible] = useState(false)

  //中医特色
  const [recordsSpecialVisible, setRecordsSpecialVisible] = useState(false)
  const [ZYTSLFFormVisible, setZYTSLFFormVisible] = useState(false)

  //传统医学 中医医术确有专长医师管理
  const [recordsTraditionalVisible, setRecordsTraditionalVisible] = useState(
    false
  )
  const [CTYXFormVisible, setCTYXFormVisible] = useState(false)
  const [CTYXAgainVisible, setCTYXAgainVisible] = useState(false)
  const [activeFilingType, setActiveFilingType] = useState(0)

  //抗菌药物
  const [KJYWData, setKJYWData] = useState({ isAdjustment: -1, sameNameProcurementCount: '' })
  const [KJYWOverlayVisible, setKJYWOverlayVisible] = useState(false)
  const [recordsKJYWVisible, setRecordsKJYWVisible] = useState(false)
  const [KJYWFormVisible, setKJYWFormVisible] = useState(false)
  const [KJYWTemporaryVisible, setKJYWTemporaryVisible] = useState(false)

  //三四级手术目录
  const [SSJSSFormVisible, setSSJSSFormVisible] = useState(false)
  const [recordsSSJSSVisible, setRecordsSSJSSVisible] = useState(false)
  const [SSJSSFileData, setSSJSSFileData] = useState<any>()


  const history = useHistory()

  const [againId, setAgainId] = useState<any>()

  const [againName, setAgainName] = useState<any>()

  const [currentRow, setCurrentRow] = useState<any>()

  const [pageLoading, setPageLoading] = useState(false)

  const [activeKey, setActiveKey] = useState<string | string[]>(location.state?.fillingType || FillingType.ZYTF)

  const [params, setParams] = useState<any>({
    pageSize: 10,
    pageNo: 1,
  })

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  const getData = () => {
    setPageLoading(true)
    dispatch(getSJWHTokenAsync())
      .then(unwrapResult)
      .then((token: any) => {
        setToken(token)
        axios({
          url:
            activeKey == "1"
              ? `${AXIOS_IP}/filingFreeClinic/list`
              : activeKey == "2"
              ? `${AXIOS_IP}/filingTcmPatch/list`
              : activeKey == "3"
              ? `${AXIOS_IP}/filingDecoction/list`
              : activeKey == "4"
              ? `${AXIOS_IP}/filingFeature/list`
              : activeKey == "5"
              ? `${AXIOS_IP}/filingMentor/list`
              : activeKey == "6"
              ? `${AXIOS_IP}/filingMentor/list`
              : activeKey == "8"
              ? `${AXIOS_IP}/filingAntibacterial/list`
              : activeKey == "11"
              ? `${AXIOS_IP}/filingSurgicalDirectory/list`
              : "",
          headers: {
            "Content-Type": "application/json",
            "His-Auth": token,
          },
          withCredentials: false,
          method: "POST",
          data: { 
            ...params, 
            filingType: activeKey == "5" ? 5 : activeKey == "6" ? 6 : undefined, 
            status: activeKey == "11" ? 0 : undefined
          },
        }).then((res) => {
          setPage({
            ...page,
            items: res.data.data?.records || res.data.data?.list,
            total: res.data.data?.total,
          })
          setPageLoading(false)
        })
      })
  }

  const onChange = (key: string | string[]) => {
    setActiveKey(key)
    setParams({
      ...params,
      pageNo: 1,
      pageSize: 10,
    })
  }

  // 添加键盘事件监听
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Control' || event.key === 'Meta') { // Meta 键是 Mac 上的 Command 键
        setCtrlPressed(true)
      }
    }

    const handleKeyUp = (event: KeyboardEvent) => {
      if (event.key === 'Control' || event.key === 'Meta') {
        setCtrlPressed(false)
      }
    }

    // 添加事件监听
    document.addEventListener('keydown', handleKeyDown)
    document.addEventListener('keyup', handleKeyUp)

    // 清理函数
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      document.removeEventListener('keyup', handleKeyUp)
    }
  }, [])

  useEffect(() => {
    if (activeKey) {
      getData()
    }
  }, [params])

  return (
    <Col className={`${styles.container} ${styles.containerBA}`}>
      <TabBar defaultActiveKey={"1"}>
        <TabPane key="1" tab="备案管理">
          {showContent ? <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            height: 'calc(100% - 20px)',
            flexDirection: 'column',
            backgroundColor: '#fff',
            fontSize: '18px',
            marginTop: '15px',
            borderRadius: '10px',
            cursor: 'pointer'
          }}>
              <img onDoubleClick={() => {
                if(ctrlPressed) {
                  setShowContent(false)
                  sessionStorage.setItem('showFilingManagement', 'false')
                }
              }} src={FillingSvg} style={{ width: 160 }} alt="" />
              <div>模块建设中</div>
          </div> :
          <Collapse activeKey={activeKey} accordion onChange={onChange}>
            <Collapse.Panel
              header="义诊备案"
              key="1"
              showArrow={false}
              extra={
                <>
                  <Button
                    type="link"
                    ghost
                    style={{ color: "#FAA038" }}
                    onClick={(e) => {
                      e.stopPropagation()
                      setRecordsYZBAVisible(true)
                    }}
                  >
                    申请记录
                  </Button>
                  <Button
                    type="primary"
                    ghost
                    onClick={(e) => {
                      e.stopPropagation()
                      setYZBAFormVisible(true)
                    }}
                  >
                    去备案
                  </Button>
                  {activeKey == "2" ? (
                    <UpOutlined style={{ paddingLeft: 10, color: "#666", fontSize: "14px" }} />
                  ) : (
                    <DownOutlined style={{ paddingLeft: 10, color: "#666", fontSize: "14px" }} />
                  )}
                </>
              }
            >
              <EditableList
                rowKey={(v, i) => `${i}`}
                columns={YZBAColumns(
                  params.pageSize * (params.pageNo - 1),
                  (action, t) => {
                    if (action === "detail") {
                      history.push({
                        pathname: "/filingManagementDetail",
                        state: { id: t.id, state: 1, type:FillingType.YZBA },
                      }) 
                    }
                  }
                )}
                loading={pageLoading}
                page={{
                  current: params.pageNo,
                  size: params.pageSize,
                  total: page.total,
                  items: page.items,
                }}
                style={{ maxHeight: "450px" }}
                onChangePage={(current, size) =>
                  setParams({
                    ...params,
                    pageNo: current,
                    pageSize: size || 10,
                  })
                }
                bordered
              />
            </Collapse.Panel>
            <Collapse.Panel
              header="中医贴敷备案"
              key="2"
              showArrow={false}
              extra={
                <>
                  <Button
                    type="link"
                    ghost
                    style={{ color: "#FAA038" }}
                    onClick={(e) => {
                      e.stopPropagation()
                      setRecordsVisible(true)
                    }}
                  >
                    申请记录
                  </Button>
                  <Button
                    type="primary"
                    ghost
                    onClick={(e) => {
                      e.stopPropagation()
                      setZYTFFormVisible(true)
                    }}
                  >
                    去备案
                  </Button>
                  {activeKey == "2" ? (
                    <UpOutlined style={{ paddingLeft: 10, color: "#666", fontSize: "14px" }} />
                  ) : (
                    <DownOutlined style={{ paddingLeft: 10, color: "#666", fontSize: "14px" }} />
                  )}
                </>
              }
            >
              <EditableList
                rowKey={(v, i) => `${i}`}
                columns={ZYTFColumns(
                  params.pageSize * (params.pageNo - 1),
                  (action, t) => {
                    if (action === "filing") {
                      axios({
                        url: `${AXIOS_IP}/filingTcmPatch/checkCommit`,
                        headers: {
                          "Content-Type": "application/json",
                          "His-Auth": token,
                        },
                        withCredentials: false,
                        method: "POST",
                        data: { id: t.id },
                      }).then((res) => {
                        if (res.data.data) {
                          setAgainId(t.id)
                          setAgainName(t.drugName)
                          setZYTFAgainVisible(true)
                        } else {
                          Modal.confirm({
                            title: "提示",
                            content: "已重新提交备案，正在审核中，无需再次提交",
                            okText: "确认",
                            cancelText: "取消",
                            cancelButtonProps: { style: { display: "none" } },
                          })
                        }
                      })
                    } else if (action === "detail") {
                      history.push({
                        pathname: "/filingManagementDetail",
                        state: { id: t.id, state: 1, type: FillingType.ZYTF },
                      })
                    }
                  }
                )}
                loading={pageLoading}
                page={{
                  current: params.pageNo,
                  size: params.pageSize,
                  total: page.total,
                  items: page.items,
                }}
                style={{ maxHeight: "450px" }}
                onChangePage={(current, size) =>
                  setParams({
                    ...params,
                    pageNo: current,
                    pageSize: size || 10,
                  })
                }
                bordered
              />
            </Collapse.Panel>
            <Collapse.Panel
              header="代煎代配"
              key="3"
              showArrow={false}
              extra={
                <>
                  <Button
                    type="link"
                    ghost
                    style={{ color: "#FAA038" }}
                    onClick={(e) => {
                      e.stopPropagation()
                      setRecordsDJDPVisible(true)
                    }}
                  >
                    申请记录
                  </Button>
                  <Button
                    type="primary"
                    ghost
                    onClick={(e) => {
                      e.stopPropagation()
                      setDJDPFormVisible(true)
                    }}
                  >
                    去备案
                  </Button>
                  {activeKey == "2" ? (
                    <UpOutlined style={{ paddingLeft: 10, color: "#666", fontSize: "14px" }} />
                  ) : (
                    <DownOutlined style={{ paddingLeft: 10, color: "#666", fontSize: "14px" }} />
                  )}
                </>
              }
            >
              <EditableList
                rowKey={(v, i) => `${i}`}
                columns={DJDPColumns(
                  params.pageSize * (params.pageNo - 1),
                  (action, t) => {
                    if (action === "detail") {
                      history.push({
                        pathname: "/filingManagementDetail",
                        state: { id: t.id, state: 1, type: FillingType.DJDP },
                      })
                    } else if (action === "filing") {
                      axios({
                        url: `${AXIOS_IP}/filingDecoction/checkCommit`,
                        headers: {
                          "Content-Type": "application/json",
                          "His-Auth": token,
                        },
                        withCredentials: false,
                        method: "POST",
                        data: { id: t.id },
                      }).then((res) => {
                        if (res.data.data) {
                          setAgainId(t.id)
                          setDJDPAgainVisible(true)
                        } else {
                          Modal.confirm({
                            title: "提示",
                            content: "已重新提交备案，正在审核中，无需再次提交",
                            okText: "确认",
                            cancelText: "取消",
                            cancelButtonProps: { style: { display: "none" } },
                          })
                        }
                      })
                    }
                  }
                )}
                loading={pageLoading}
                page={{
                  current: params.pageNo,
                  size: params.pageSize,
                  total: page.total,
                  items: page.items,
                }}
                style={{ maxHeight: "450px" }}
                onChangePage={(current, size) =>
                  setParams({
                    ...params,
                    pageNo: current,
                    pageSize: size || 10,
                  })
                }
                bordered
              />
            </Collapse.Panel>
            <Collapse.Panel
              header="中医特色疗法管理"
              key="4"
              showArrow={false}
              extra={
                <>
                  <Button
                    type="link"
                    ghost
                    style={{ color: "#FAA038" }}
                    onClick={(e) => {
                      e.stopPropagation()
                      setRecordsSpecialVisible(true)
                    }}
                  >
                    申请记录
                  </Button>
                  <Button
                    type="primary"
                    ghost
                    onClick={(e) => {
                      e.stopPropagation()
                      setZYTSLFFormVisible(true)
                    }}
                  >
                    去备案
                  </Button>
                  {activeKey == "4" ? (
                    <UpOutlined style={{ paddingLeft: 10, color: "#666", fontSize: "14px" }} />
                  ) : (
                    <DownOutlined style={{ paddingLeft: 10, color: "#666", fontSize: "14px" }} />
                  )}
                </>
              }
            >
              <EditableList
                rowKey={(v, i) => `${i}`}
                columns={ZYTSLFColumns(
                  params.pageSize * (params.pageNo - 1),
                  (action, t) => {
                    if (action === "detail") {
                      history.push({
                        pathname: "/filingManagementDetail",
                        state: { id: t.id, state: 1, type: FillingType.ZYTSLF },
                      })
                    }
                  }
                )}
                loading={pageLoading}
                page={{
                  current: params.pageNo,
                  size: params.pageSize,
                  total: page.total,
                  items: page.items,
                }}
                onChangePage={(current, size) =>
                  setParams({
                    ...params,
                    pageNo: current,
                    pageSize: size || 10,
                  })
                }
                bordered
              />
            </Collapse.Panel>
            <Collapse.Panel
              header="传统医学传承管理"
              key="5"
              showArrow={false}
              extra={
                <>
                  <Button
                    type="link"
                    ghost
                    style={{ color: "#FAA038" }}
                    onClick={(e) => {
                      e.stopPropagation()
                      setActiveFilingType(5)
                      setRecordsTraditionalVisible(true)
                    }}
                  >
                    申请记录
                  </Button>
                  <Button
                    type="primary"
                    ghost
                    onClick={(e) => {
                      e.stopPropagation()
                      setActiveFilingType(5)
                      setCTYXFormVisible(true)
                    }}
                  >
                    去备案
                  </Button>
                  {activeKey == "5" ? (
                    <UpOutlined style={{ paddingLeft: 10, color: "#666", fontSize: "14px" }} />
                  ) : (
                    <DownOutlined style={{ paddingLeft: 10, color: "#666", fontSize: "14px" }} />
                  )}
                </>
              }
            >
              <EditableList
                rowKey={(v, i) => `${i}`}
                columns={CTYXColumns(
                  params.pageSize * (params.pageNo - 1),
                  (action, t) => {
                    if (action === "detail") {
                      history.push({
                        pathname: "/filingManagementDetail",
                        state: { id: t.id, state: 1, type: FillingType.CTYX, filingType: 5 },
                      })
                    } else if (action === "filing") {
                      axios({
                        url: `${AXIOS_IP}/filingMentor/checkCommit`,
                        headers: {
                          "Content-Type": "application/json",
                          "His-Auth": token,
                        },
                        withCredentials: false,
                        method: "POST",
                        data: { id: t.id, filingType: 5 },
                      }).then((res) => {
                        if (res.data.data) {
                          setAgainId(t.id)
                          setActiveFilingType(5)
                          setCTYXAgainVisible(true)
                        } else {
                          Modal.confirm({
                            title: "提示",
                            content: "已重新提交备案，正在审核中，无需再次提交",
                            okText: "确认",
                            cancelText: "取消",
                            cancelButtonProps: { style: { display: "none" } },
                          })
                        }
                      })
                    }
                  }
                )}
                loading={pageLoading}
                page={{
                  current: params.pageNo,
                  size: params.pageSize,
                  total: page.total,
                  items: page.items,
                }}
                onChangePage={(current, size) =>
                  setParams({
                    ...params,
                    pageNo: current,
                    pageSize: size || 10,
                  })
                }
                bordered
              />
            </Collapse.Panel>
            <Collapse.Panel
              header="中医医术确有专长医师管理"
              key="6"
              showArrow={false}
              extra={
                <>
                  <Button
                    type="link"
                    ghost
                    style={{ color: "#FAA038" }}
                    onClick={(e) => {
                      e.stopPropagation()
                      setActiveFilingType(6)
                      setRecordsTraditionalVisible(true)
                    }}
                  >
                    申请记录
                  </Button>
                  <Button
                    type="primary"
                    ghost
                    onClick={(e) => {
                      e.stopPropagation()
                      setActiveFilingType(6)
                      setCTYXFormVisible(true)
                    }}
                  >
                    去备案
                  </Button>
                  {activeKey == "6" ? (
                    <UpOutlined style={{ paddingLeft: 10, color: "#666", fontSize: "14px" }} />
                  ) : (
                    <DownOutlined style={{ paddingLeft: 10, color: "#666", fontSize: "14px" }} />
                  )}
                </>
              }
            >
              <EditableList
                rowKey={(v, i) => `${i}`}
                columns={CTYXColumns(
                  params.pageSize * (params.pageNo - 1),
                  (action, t) => {
                    if (action === "detail") {
                      history.push({
                        pathname: "/filingManagementDetail",
                        state: { id: t.id, state: 1, type: FillingType.CTYX, filingType: 6 },
                      })
                    } else if (action === "filing") {
                      axios({
                        url: `${AXIOS_IP}/filingMentor/checkCommit`,
                        headers: {
                          "Content-Type": "application/json",
                          "His-Auth": token,
                        },
                        withCredentials: false,
                        method: "POST",
                        data: { id: t.id, filingType: 6 },
                      }).then((res) => {
                        if (res.data.data) {
                          setAgainId(t.id)
                          setActiveFilingType(6)
                          setCTYXAgainVisible(true)
                        } else {
                          Modal.confirm({
                            title: "提示",
                            content: "已重新提交备案，正在审核中，无需再次提交",
                            okText: "确认",
                            cancelText: "取消",
                            cancelButtonProps: { style: { display: "none" } },
                          })
                        }
                      })
                    }
                  }
                )}
                loading={pageLoading}
                page={{
                  current: params.pageNo,
                  size: params.pageSize,
                  total: page.total,
                  items: page.items,
                }}
                onChangePage={(current, size) =>
                  setParams({
                    ...params,
                    pageNo: current,
                    pageSize: size || 10,
                  })
                }
                bordered
              />
            </Collapse.Panel>
            <Collapse.Panel
              header="抗菌药物供应目录备案"
              key="8"
              showArrow={false}
              extra={
                <>
                  <Button
                    type="link"
                    ghost
                    style={{ color: "#FAA038" }}
                    onClick={(e) => {
                      e.stopPropagation()
                      setRecordsKJYWVisible(true)
                    }}
                  >
                    申请记录
                  </Button>
                  <Dropdown
                    overlay={
                      <Menu>
                        <Menu.Item
                          onClick={({ domEvent }) => {
                            domEvent.stopPropagation()
                            setKJYWFormVisible(true)
                          }}
                        >
                          供应目录备案
                        </Menu.Item>
                        <Menu.Item
                          onClick={({ domEvent }) => {
                            domEvent.stopPropagation()
                            setAgainId('')
                            setKJYWTemporaryVisible(true)
                          }}
                        >
                          临时采购备案
                        </Menu.Item>
                      </Menu>
                    }
                    overlayStyle={{ height: "100px" }}
                    placement="bottomRight"
                    visible={KJYWOverlayVisible}
                    onVisibleChange={(v) => setKJYWOverlayVisible(v)}
                  >
                    <Button
                      type="primary"
                      ghost
                      onClick={(e) => {
                        e.stopPropagation()
                        setKJYWData({ isAdjustment: -1, sameNameProcurementCount: '' })
                        setAgainId('')
                        setKJYWOverlayVisible(true)
                      }}
                    >
                      去备案
                    </Button>
                  </Dropdown>
                  {activeKey == "8" ? (
                    <UpOutlined style={{ paddingLeft: 10, color: "#666", fontSize: "14px" }} />
                  ) : (
                    <DownOutlined style={{ paddingLeft: 10, color: "#666", fontSize: "14px" }} />
                  )}
                </>
              }
            >
              <EditableList
                rowKey={(v, i) => `${i}`}
                columns={KJYWColumns(
                  params.pageSize * (params.pageNo - 1),
                  (action, t) => {
                    if (action === "detail") {
                      history.push({
                        pathname: "/filingManagementDetail",
                        state: {
                          id: t.id,
                          state: t.childFilingType,
                          type: FillingType.KJYW,
                          isAdjustmentName: t.isAdjustmentName,
                          sameNameProcurementCount: t.sameNameProcurementCount,
                        },
                      })
                    } else if (action === "filing") {
                      setAgainId(t.id)
                      setKJYWData({
                        isAdjustment: t.isAdjustment,
                        sameNameProcurementCount: t.sameNameProcurementCount,
                      })
                      if(t.childFilingType == 0) {
                        setKJYWFormVisible(true)
                      } else {
                        setKJYWTemporaryVisible(true)
                      }
                    }
                  }
                )}
                loading={pageLoading}
                page={{
                  current: params.pageNo,
                  size: params.pageSize,
                  total: page.total,
                  items: page.items,
                }}
                onChangePage={(current, size) =>
                  setParams({
                    ...params,
                    pageNo: current,
                    pageSize: size || 10,
                  })
                }
                bordered
              />
            </Collapse.Panel>
            <Collapse.Panel
              header="三四级手术目录报备"
              key="11"
              showArrow={false}
              extra={
                <>
                  <Button
                    type="link"
                    ghost
                    style={{ color: "#FAA038" }}
                    onClick={(e) => {
                      e.stopPropagation()
                      setRecordsSSJSSVisible(true)
                    }}
                  >
                    申请记录
                  </Button>
                  <Button
                    type="primary"
                    ghost
                    onClick={(e) => {
                      e.stopPropagation()
                      if(activeKey == "11") {
                        setAgainId(page.items?.[0]?.id)
                        setSSJSSFileData(page.items?.[0]?.reportFile)
                        setSSJSSFormVisible(true)
                      } else {
                        axios({
                          url: `${AXIOS_IP}/filingSurgicalDirectory/list`,
                          headers: {
                            "Content-Type": "application/json",
                            "His-Auth": token,
                          },
                          withCredentials: false,
                          method: "POST",
                          data: { ...params, status: 0 },
                        }).then((res) => {
                          setAgainId(res.data.data?.list?.[0]?.id)
                          setSSJSSFileData(res.data.data?.list?.[0]?.reportFile)
                          setSSJSSFormVisible(true)
                        })
                      }
                    }}
                  >
                    去报备
                  </Button>
                  {activeKey == "11" ? (
                    <UpOutlined style={{ paddingLeft: 10, color: "#666", fontSize: "14px" }} />
                  ) : (
                    <DownOutlined style={{ paddingLeft: 10, color: "#666", fontSize: "14px" }} />
                  )}
                </>
              }
            >
              <EditableList
                rowKey={(v, i) => `${i}`}
                columns={SSJSSColumns(
                  params.pageSize * (params.pageNo - 1),
                  (action, t) => {
                    if (action === "detail") {
                      history.push({
                        pathname: "/filingManagementDetail",
                        state: {
                          id: t.id,
                          state: 1,
                          fileData: t.reportFile,
                          type: FillingType.SSJSS,
                        },
                      })
                    } else if (action === "filing") {
                      setSSJSSFileData(t.reportFile)
                      setAgainId(t.id)
                      setSSJSSFormVisible(true)
                    }
                  }
                )}
                loading={pageLoading}
                pagination={false}
                page={{
                  current: params.pageNo,
                  size: params.pageSize,
                  total: page.total,
                  items: page.items,
                }}
                onChangePage={(current, size) =>
                  setParams({
                    ...params,
                    pageNo: current,
                    pageSize: size || 10,
                  })
                }
                bordered
              />
            </Collapse.Panel>
          </Collapse>}
        </TabPane>
      </TabBar>

      {/* 义诊备案 */}
      <RecordsYZBAModal
        visible={recordsYZBAVisible}
        token={token}
        onOk={() => setRecordsYZBAVisible(false)}
        onCancel={() => setRecordsYZBAVisible(false)}
      />
      <YZBAFormModal
        visible={YZBAFormVisible}
        token={token}
        onOk={() => {
          setYZBAFormVisible(false)
          getData()
        }}
        onCancel={() => setYZBAFormVisible(false)}
      />

      {/* 代煎代配 */}
      <RecordsDJDPModal
        visible={recordsDJDPVisible}
        token={token}
        onOk={() => setRecordsDJDPVisible(false)}
        onCancel={() => setRecordsDJDPVisible(false)}
      />
      <DJDPFormModal
        visible={DJDPFormVisible}
        token={token}
        onOk={() => setDJDPFormVisible(false)}
        onCancel={() => setDJDPFormVisible(false)}
      />
      <DJDPAgainModal
        visible={DJDPAgainVisible}
        token={token}
        state={1}
        filingDecoctionRecordId={againId}
        onOk={() => setDJDPAgainVisible(false)}
        onCancel={() => setDJDPAgainVisible(false)}
      />

      {/* 中医贴敷 */}
      <RecordsModal
        visible={recordsVisible}
        token={token}
        onOk={() => setRecordsVisible(false)}
        onCancel={() => setRecordsVisible(false)}
      />
      <ZYTFFormModal
        visible={ZYTFFormVisible}
        token={token}
        onOk={() => {
          setZYTFFormVisible(false)
          getData()
        }}
        onCancel={() => setZYTFFormVisible(false)}
      />
      <ZYTFAgainModal
        visible={ZYTFAgainVisible}
        token={token}
        filingTcmPatchRecordId={againId}
        againName={againName}
        onOk={() => setZYTFAgainVisible(false)}
        onCancel={() => setZYTFAgainVisible(false)}
      />

      {/* 中医特色疗法管理 */}
      <RecordsSpecialModal
        visible={recordsSpecialVisible}
        token={token}
        onOk={() => setRecordsSpecialVisible(false)}
        onCancel={() => setRecordsSpecialVisible(false)}
      />
      <ZYTSLFFormModal
        visible={ZYTSLFFormVisible}
        token={token}
        onOk={() => {
          setZYTSLFFormVisible(false)
          getData()
        }}
        onCancel={() => setZYTSLFFormVisible(false)}
      />

      {/* 传统医学传承管理 */}
      <RecordsCTYXModal
        visible={recordsTraditionalVisible}
        filingType={activeFilingType}
        token={token}
        onOk={() => setRecordsTraditionalVisible(false)}
        onCancel={() => setRecordsTraditionalVisible(false)}
      />
      <CTYXFFormModal
        visible={CTYXFormVisible}
        token={token}
        filingType={activeFilingType}
        onOk={() => {
          setCTYXFormVisible(false)
          getData()
        }}
        onCancel={() => setCTYXFormVisible(false)}
      />
      <CTYXAgainModal
        visible={CTYXAgainVisible}
        token={token}
        filingType={activeFilingType}
        state={1}
        filingRecordId={againId}
        onOk={() => setCTYXAgainVisible(false)}
        onCancel={() => setCTYXAgainVisible(false)}
      />

      {/* 抗菌药物 */}
      <RecordsLKJYWModal
        visible={recordsKJYWVisible}
        token={token}
        onOk={() => setRecordsKJYWVisible(false)}
        onCancel={() => setRecordsKJYWVisible(false)}
      />
      <KJYWFormModal
        visible={KJYWFormVisible}
        token={token}
        againId={againId}
        isFiling={true}
        onOk={() => {
          setKJYWFormVisible(false)
          getData()
        }}
        onCancel={() => setKJYWFormVisible(false)}
      />
      <KJYWTemporaryModal
        visible={KJYWTemporaryVisible}
        token={token}
        againId={againId}
        isFiling={true}
        KJYWData={KJYWData}
        onOk={() => {
          setKJYWTemporaryVisible(false)
          getData()
        }}
        onCancel={() => {
          setKJYWTemporaryVisible(false)
          setKJYWData({isAdjustment: -1, sameNameProcurementCount: ''})
        }}
      />

      {/* 三四级手术目录 */}
      <RecordsSurgicalModal
        visible={recordsSSJSSVisible}
        token={token}
        onOk={() => setRecordsSSJSSVisible(false)}
        onCancel={() => setRecordsSSJSSVisible(false)}
      />
      <SSJSSFormModal
        visible={SSJSSFormVisible}
        token={token}
        againId={againId}
        fileData={SSJSSFileData}
        onOk={() => {
          setSSJSSFormVisible(false)
          getData()
        }}
        onCancel={() => setSSJSSFormVisible(false)}
      />
    </Col>
  )
}
